<template>
<div id="retours-nouveau">
    <vs-popup fullscreen title="Ligne BL" :active.sync="popupActive">

        <div class="flex flex-wrap justify-between items-center">

            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ commandesList.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : commandesList.length }} of {{ commandesList.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                            <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                            <span>150</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <div class="w-1/3">
                <v-select label="designation" v-model="moisSelect" :options="mois" />
            </div>

            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
            </div>
        </div>
        <!-- <ag-grid-vue ref="agGridTable" @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" @row-double-clicked="onArticleChecked" :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 h-500 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="commandesList" :pagination="true" :paginationPageSize="paginationPageSize">
            </ag-grid-vue> -->
        <div style="margin-bottom: 30px;margin-top: 30px;">
            <ag-grid-vue :pagination="true" :paginationPageSize="paginationPageSize" style="height:68vh" class="ag-theme-material w-100 ag-grid-table" @row-double-clicked="onArticleChecked" rowSelection="single" :gridOptions="gridOptions" :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="commandesList" @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered"></ag-grid-vue>
        </div>

    </vs-popup>

    <div class="vx-card" ref="aze">

        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4>{{$store.state.AppActiveUser.societe.nom}}</h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <div class="flex mb-12">
                    <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
                        <label class="block text-gray-700 text-sm font-bold mb-2">Code client</label>

                        <div class="mt-2">
                            <vs-input readonly class="w-full" icon-pack="feather" icon="icon-info" v-model="id_user" />
                        </div>
                    </div>
                    <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
                        <label class="block text-gray-700 text-sm font-bold mb-2">Crédit autorisé</label>

                        <div class="mt-2">
                            <vs-input readonly class="w-full" icon-pack="feather" icon="icon-info" v-model="CreditA" />
                        </div>
                    </div>
                    <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
                        <label class="block text-gray-700 text-sm font-bold mb-2">Magasin</label>

                        <div class="mt-2">
                            <vs-input readonly v-on:click="doSomething" class="w-full" icon-pack="feather" icon="icon-info" v-model="Magasin" />
                        </div>
                    </div>
                    <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
                        <label class="block text-gray-700 text-sm font-bold mb-2">Date</label>

                        <div class="mt-2">
                            <vs-input readonly class="w-full" icon-pack="feather" icon="icon-info" v-model="DateCourant" />
                        </div>
                    </div>
                </div>
                <div class="flex mb-12">

                    <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
                    </div>

                    <div class="w-1/2 bg-grid-color-secondary h-12 px-2">
                        <label class="block text-gray-700 text-sm font-bold mb-2">Motif Retour</label>
                        <div class="mt-2">
                            <v-select class="w-full" label="designation" value="id" v-model="selectedMotif" :options="optionsMotif" />
                        </div>
                    </div>

                    <div class="w-1/4 bg-grid-color-secondary h-12 px-2">
                    </div>

                </div>
            </div>
        </div>
    </div>

    <br />

    <div class="vx-card p-6">

        <vs-table ref="table" :data="retoursList" hoverFlat>

            <template slot="thead">
                <vs-th class="w-0/12"> </vs-th>
                <vs-th class="w-2/12"> N° BL </vs-th>
                <vs-th class="w-2/12"> Date Commande </vs-th>
                <vs-th class="w-3/12"> Article </vs-th>
                <vs-th class="w-2/12"> Quantité reçus </vs-th>
                <vs-th class="w-2/12"> Quantité retour </vs-th>
                <vs-th class="w-0/12"> </vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td class="text-center">
                            <vs-button size="small" ref="focusHeare" color="primary" type="gradient" icon-pack="feather" icon="icon-plus" @click="addLine(indextr)"></vs-button>
                        </vs-td>

                        <vs-td class="text-center" v-model="tr.ncommande">
                            {{ tr.ncommande }}
                        </vs-td>

                        <vs-td class="text-center" v-model="tr.cree_le">
                            {{ tr.cree_le.substring(0,10) }}
                        </vs-td>

                        <vs-td :state="'success'" class="text-center" v-model="tr.article_designation">
                            {{ tr.article_designation }}
                        </vs-td>

                        <vs-td class="text-center" v-model="tr.quantite">
                            {{ tr.quantite }}
                        </vs-td>

                        <vs-td v-model="tr.quantite_retour" v-if="tr.quantite != ''" class="text-center quantite_retour" ref="quantite_retour" contenteditable='true' @keypress.native="validerNumber($event,indextr)" @keyup.native="validerQte($event,indextr)">
                            {{ tr.quantite_retour }}
                        </vs-td>

                        <vs-td v-else class="text-center quantite_retour" ref="quantite_retour" v-model="tr.quantite_retour">
                            <p> {{ tr.quantite_retour }} </p>
                        </vs-td>

                        <vs-td v-if="indextr != retoursList.length - 1" class="text-center">
                            <vs-button size="small" color="danger" type="gradient" icon-pack="feather" icon="icon-trash" @click="deleteData(indextr)"></vs-button>
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>
        </vs-table>

        <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button @click="Confirmer" ref="loadableButton" id="button-with-loading" type="relief" color="primary" class="ml-auto mt-2 vs-con-loading__container" :disabled="validateButton">Confirmer</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Initialiser</vs-button>
        </div>

    </div>

</div>
</template>

<script>
import {
    AgGridVue
} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import indexCommande from "../../http/requests/commande/index.js";
import indexRetour from "../../http/requests/retour/index.js";

export default {
    components: {
        AgGridVue,
        vSelect,
    },
    data() {
        return {
            mois: [],
            moisSelect: null,
            CreditA: "",
            Magasin: "",
            id_user: "",
            DateCourant: "",
            popupActive: false,
            optionsMotif: [{
                    id: 1,
                    designation: 'produits périmés'
                },
                {
                    id: 2,
                    designation: 'lot retiré'
                },
                {
                    id: 3,
                    designation: 'produits cassés '
                },
                {
                    id: 4,
                    designation: 'produits date proche '
                },
                {
                    id: 5,
                    designation: 'produits sans vignette '
                },
                {
                    id: 6,
                    designation: 'produits avec défaillance de contenu '
                },
                {
                    id: 7,
                    designation: 'sur stock '
                }
            ],
            selectedMotif: {},
            retoursList: [{
                ncommande: "",
                cree_le: "",
                code_article: "",
                article_designation: "",
                quantite: "",
                quantite_retour: ""
            }],
            paginationPageSize: 20,
            searchQuery: '',
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                resizable: true,
                filter: true,
            },
            columnDefs: [{
                    headerName: 'N° BL',
                    field: 'Document_No',
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: 'Date commande',
                    field: 'Posting_Date',
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: 'Article',
                    field: 'Description',
                    cellStyle: {
                        color: 'black'
                    }
                },
                {
                    headerName: 'Quantité',
                    field: 'Quantity',
                    cellStyle: {
                        color: 'black'
                    }
                },
            ],
            commandesList: [],
            selectedLineIndex: 0,
            validateButton: true
        }
    },
    watch: {
        moisSelect: function (val) {
            this.$vs.loading();
            var today = new Date();
            var yyyy = today.getFullYear();
            today = yyyy + "-" + String("0" + val.id).slice(-2) + "-01";
            indexRetour.getAll(this.$store.state.AppActiveUser.customer_No, today, null).then(response => {
                this.$vs.loading.close();
                this.commandesList = response.data.value;
            }).catch(error => {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: 'Erreur s\'est produite lors de la récupération des données',
                    text: error.data,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circles'
                })
            })
        },
        selectedMotif: function () {
            this.BtnIsDisabled();
        }
    },
    computed: {
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages()
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        }
    },
    methods: {
        onMounthChange(val) {
            console.log(val)
        },
        getLast3Months() {
            var monthNames = [{
                    id: 1,
                    designation: "Janvier"
                },
                {
                    id: 2,
                    designation: "Février"
                },
                {
                    id: 3,
                    designation: "Mars"
                },
                {
                    id: 4,
                    designation: "Avril"
                },
                {
                    id: 5,
                    designation: "Mai"
                },
                {
                    id: 6,
                    designation: "Juin"
                },
                {
                    id: 7,
                    designation: "Juillet"
                },
                {
                    id: 8,
                    designation: "Août"
                },
                {
                    id: 9,
                    designation: "Septembre"
                },
                {
                    id: 10,
                    designation: "Octobre"
                },
                {
                    id: 11,
                    designation: "Novembre"
                },
                {
                    id: 12,
                    designation: "Décembre"
                }
            ];
            var today = new Date();
            var last3Months = []
            for (var i = 0; i < 6; i++) {
                last3Months.push({
                    id: monthNames[(today.getMonth() - i)].id,
                    designation: monthNames[(today.getMonth() - i)].designation + ' - ' + today.getFullYear()
                });
            }
            this.mois = last3Months;
            this.moisSelect = last3Months[0];
        },
        Confirmer() {
            var list_retour = this.retoursList;
            for (var i = 0; i < list_retour.length; i++) {
                if (list_retour[i].ncommande == "")
                    list_retour.splice(i, 1)
            }
            list_retour = list_retour.map(function (obj) {
                return {
                    ncommande: obj.ncommande,
                    codeArticle: obj.code_article,
                    quantiteRetour: obj.quantite_retour
                };
            });
            const request_body = {
                customerNo: this.id_user,
                dateSession: this.DateCourant,
                motifRetour: this.selectedMotif.designation,
                listRetour: list_retour
            };
            indexRetour.ValiderRetour(request_body).then(response => {
                    console.log(response)
                    this.$vs.loading.close();
                    this.LoadDateSession();
                    this.retoursList = [{
                        ncommande: "",
                        cree_le: "",
                        code_article: "",
                        article_designation: "",
                        quantite: "",
                        quantite_retour: ""
                    }];
                    this.selectedMotif = {};
                    this.SelectedRow = 0;
                    this.$vs.notify({
                        time: 10000,
                        title: "Enregistrement avec succès",
                        text: "Le retour que vous saisie a été enregistrée avec succès !",
                        color: "primary",
                        iconPack: "feather",
                        icon: "icon-check",
                        position: "top-right"
                    });
                    this.$vs.loading.close();
                })
                .catch(error => {
                    this.LoadDateSession();
                    console.log(error);
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 10000,
                        title: "Erreur s'est produite",
                        text: error.response,
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circles"
                    });
                })
        },
        BtnIsDisabled: function () {
            if (this.selectedMotif == null) {
                this.validateButton = true;
                return;
            }
            if (this.selectedMotif.id == undefined) {
                this.validateButton = true;
                return;
            }
            if (this.retoursList.length == 1) {
                this.validateButton = true;
                return;
            }
            for (var i = 0; i < (this.retoursList.length - 1); i++) {
                var element = this.retoursList[i]
                var data = element.quantite_retour.toString().replace(/\s/g, '').toString()
                if (data == "") {
                    this.validateButton = true;
                    return;
                }
            }
            this.validateButton = false;
        },
        reset_data() {
            this.selectedMotif = {};
            this.retoursList = [{
                ncommande: "",
                cree_le: "",
                code_article: "",
                article_designation: "",
                quantite: "",
                quantite_retour: ""
            }];
            this.selectedLineIndex = 0;
        },
        validerQte(e, indextr) {
            var val = parseInt(e.target.innerText.replace(/\s/g, '').toString())
            if (e.keyCode === 13) {
                if (val > 0 && val != "") {
                    this.retoursList[indextr].quantite_retour = val
                    this.$nextTick(function () {
                        this.$refs["focusHeare"][this.retoursList.length - 1].$el.focus();
                    });
                }
                this.BtnIsDisabled();
            }
        },
        validerNumber(e, indextr) {
            var qte = this.retoursList[indextr].quantite
            var retour = parseInt(e.target.textContent.replace(/\s/g, '').toString() + e.key)
            if (!/^\d+$/.test(e.key) || qte < retour || retour == 0) {
                e.preventDefault();
            }
        },
        addLine(indextr) {
            this.popupActive = true
            this.selectedLineIndex = indextr
        },
        deleteData(indextr) {
            if (this.retoursList.length == 1) {
                this.retoursList = [{
                    ncommande: "",
                    cree_le: "",
                    code_article: "",
                    article_designation: "",
                    quantite: "",
                    quantite_retour: ""
                }]
                return;
            }
            this.retoursList.splice(indextr, 1);
            this.BtnIsDisabled();
        },
        onFirstDataRendered(params) {
            params.api.sizeColumnsToFit();
        },
        onArticleChecked() {
            var selectedLine = this.gridApi.getSelectedRows()[0];
            this.popupActive = false;
            this.retoursList[this.selectedLineIndex].ncommande = selectedLine.Document_No
            this.retoursList[this.selectedLineIndex].cree_le = selectedLine.Posting_Date
            this.retoursList[this.selectedLineIndex].article_designation = selectedLine.Description
            this.retoursList[this.selectedLineIndex].quantite = selectedLine.Quantity
            this.retoursList[this.selectedLineIndex].quantite_retour = ""
            this.retoursList[this.selectedLineIndex].code_article = selectedLine.No
            if (this.retoursList[this.retoursList.length - 1].quantite != "")
                this.retoursList.push({
                    ncommande: "",
                    cree_le: "",
                    code_article: "",
                    article_designation: "",
                    quantite: "",
                    quantite_retour: ""
                })
            this.$nextTick(function () {
                this.$refs["quantite_retour"][this.selectedLineIndex].$el.focus();
            });
        },
        onGridReady(params) {
            this.gridColumnApi.setColumnWidth('Document_No', this.columnWidth(25));
            this.gridColumnApi.setColumnWidth('Posting_Date', this.columnWidth(25));
            this.gridColumnApi.setColumnWidth('Description', this.columnWidth(25));
            this.gridColumnApi.setColumnWidth('Quantity', this.columnWidth(25));
            params.api.sizeColumnsToFit();
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val)
        },
        columnWidth: function (percentage) {
            // console.log(this.$refs.agGridTable)
            // console.log(this.$refs.agGridTable.clientHeight)
            // console.log(this.$refs.agGridTable.clientWidth)
            // var div = this.$refs.agGridTable.$el;
            // console.log(div.clientWidth)
            // var parent = div.parent();
            var width = (window.innerWidth - 200) * percentage / 100; // Pixel calculation
            return width;
        },
        doSomething() {},
        LoadDateSession() {
            var today = new Date(Date.now());
            var dd = String(today.getDate()).padStart(2, "0");
            var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = today.getFullYear();
            var time =
                today.getHours() +
                ":" +
                String(today.getMinutes()).padStart(2, "0") +
                ":" +
                today.getSeconds();
            today = dd + "-" + mm + "-" + yyyy + " " + time;
            this.DateCourant = today;
            this.DateLivraison = null;
        },
        LoadData() {
            indexCommande.GetEntete(this.$store.state.AppActiveUser.customer_No).then(response => {
                this.id_user = response.data.value[0].No,
                    this.Magasin = response.data.value[0].Location_Code,
                    this.CreditA = response.data.value[0].Credit_Limit_LCY
            }).catch(error => {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: 'Erreur s\'est produite lors de la récupération des données',
                    text: error.data,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circles'
                })
            })
            this.getLast3Months();

        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridColumnApi = this.gridOptions.columnApi;
    },
    created() {
        this.$vs.loading();
        this.LoadDateSession();
        if (this.$store.state.AppActiveUser.id != 0) {
            this.LoadData();
        }
        this.$store.subscribe(mutation => {
            if (mutation.type === "UPDATE_USER_INFO") {
                this.LoadData();
            }
        });
    }
}
</script>

<style lang="scss">
.ag-theme-material {
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    // font-family: "Trebuchet MS", Arial, Tahoma, Serif;
    // font-family: "Avenir", Helvetica, Arial, sans-serif;
}

// .ag-theme-material .ag-row {
//     border-style: solid;
//     border-color: #000000;
//     border-width: 2;
// }

.ag-header-cell-label {
    /* Necessary to allow for text to grow vertically */
    height: 20%;
    padding: 50 !important;
}

.ag-theme-material .ag-header {
    // border-style: solid;
    // font-family: 'Avenir', Helvetica, Arial, sans-serif;
    // border-color: #000000;
    background: #002b5c;
    color: white;
    // font-size: 20%;
    // height: 48px;
    // border-width: 0;
}

.ag-row-hover {
    /* putting in !important so it overrides the theme's styling as it hovers the row also */
    background-color: #dfdfff !important;
}

#retours-nouveau {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000000;

    .vs-table {
        border-collapse: separate;
        // border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
            box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

            td {
                align-items: center;
                justify-content: center;
                text-align: center;
                vertical-align: middle;

                &:first-child {
                    border-top-left-radius: 0.5rem;
                    border-bottom-left-radius: 0.5rem;
                }

                &:last-child {
                    border-top-right-radius: 0.5rem;
                    border-bottom-right-radius: 0.5rem;
                }

                &.img-container {
                    span {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .product-img {
                        height: 110px;
                    }
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 5;
                padding-bottom: 5;
                color: "primary";
                background: #002b5c;
                justify-content: center;

                .vs-table-text {
                    //text-transform: uppercase;
                    font-weight: 600;
                    color: white;
                    justify-content: center;
                }
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .product-name {
        max-width: 23rem;
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        >span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search {
            padding-top: 0;

            .vs-table--search-input {
                padding: 0.9rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .quantite_retour {
        color: green;
    }

    .quantite_retour:focus {
        outline: none !important;
        border: 1px solid #002b5c;
        box-shadow: 0 0 10px #719ECE;
    }
}

// #retours-nouveau {
//     font-family: 'Avenir', Helvetica, Arial, sans-serif;
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
//     color: #000000;

//     .vs-con-table {

//         .product-name {
//             max-width: 23rem;
//         }

//         .vs-table--header {
//             display: flex;
//             flex-wrap: wrap-reverse;
//             margin-left: 1.5rem;
//             margin-right: 1.5rem;

//             >span {
//                 display: flex;
//                 flex-grow: 1;
//             }

//             .vs-table--search {
//                 padding-top: 0;

//                 .vs-table--search-input {
//                     padding: 0.9rem 2.5rem;
//                     font-size: 1rem;

//                     &+i {
//                         left: 1rem;
//                     }

//                     &:focus+i {
//                         left: 1rem;
//                     }
//                 }
//             }
//         }

//         .vs-table {
//             border-collapse: separate;
//             border-spacing: 0 1.3rem;
//             padding: 0 1rem;

//             tr {
//                 box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

//                 td {
//                     padding: 10px;
//                     justify-content: center;

//                     &:first-child {
//                         border-top-left-radius: .5rem;
//                         border-bottom-left-radius: .5rem;
//                     }

//                     &:last-child {
//                         border-top-right-radius: .5rem;
//                         border-bottom-right-radius: .5rem;
//                     }

//                     &.img-container {
//                         // width: 1rem;
//                         // background: #fff;

//                         span {
//                             display: flex;
//                             justify-content: flex-start;
//                         }

//                         .product-img {
//                             height: 110px;
//                         }
//                     }
//                 }

//                 td.td-check {
//                     padding: 20px !important;

//                 }
//             }
//         }

//         .vs-table--thead {
//             th {
//                 padding-top: 5;
//                 padding-bottom: 5;
//                 color: "primary";
//                 background: #002b5c;
//                 justify-content: center;

//                 .vs-table-text {
//                     //text-transform: uppercase;
//                     font-weight: 600;
//                     color: white;
//                     justify-content: center;
//                 }
//             }

//             th.td-check {
//                 padding: 0 15px !important;
//                 color: white;
//             }

//             tr {
//                 background: none;
//                 box-shadow: primary;
//             }
//         }

//         .vs-table--pagination {
//             justify-content: center;
//         }

//         .quantite_retour {
//             color: green;
//         }

//         .quantite_retour:focus {
//             outline: none !important;
//             border: 1px solid #002b5c;
//             box-shadow: 0 0 10px #719ECE;
//         }
//     }
// }
</style>
